export const mockRegistrationModelSerialCheckRequest = 'uid';
